import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {server} from './constants'
import { promise } from 'protractor';

@Injectable()
export class QueryService {

  private httpAddress = server;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  }

  constructor(private http: HttpClient) { }


  getDateQuery(postData): Promise <any> {
    // get the selected client then return info also put in localStorage
    return this.http.post(this.httpAddress + 'api/query/queryshipped', postData, this.httpOptions)
    .toPromise()
    .then(selectedClient => selectedClient)
    .catch(err => console.log(err));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/query.service.ts